import { format } from 'date-fns'

export function todaysDate(value) {
  return format(new Date(), 'EEEE, MMMM d, yyyy')
}
